import readingRealBehavior from '../blog-posts/reading-real-behavior';
import theBridgeBetweenSpecsAndShipping from '../blog-posts/the-bridge-between-specs-and-shipping';
import verifyingTheLoopBeforeShipping from '../blog-posts/verifying-the-loop-before-shipping';
import contractsForCoordination from '../blog-posts/contracts-for-coordination';
import debuggingWithTraceability from '../blog-posts/debugging-with-traceability';
import adaptingFasterThanTheTaskShifts from '../blog-posts/adapting-faster-than-the-task-shifts';

export const BLOGS = [
  readingRealBehavior,
  theBridgeBetweenSpecsAndShipping,
  verifyingTheLoopBeforeShipping,
  contractsForCoordination,
  debuggingWithTraceability,
  adaptingFasterThanTheTaskShifts,
];

export const getBlogBySlug = (slug) => BLOGS.find((blog) => blog.slug === slug || String(blog.id) === String(slug));

export const getBlogExcerpt = (blog) => {
  const firstSection = blog.sections?.[0];
  const firstText = firstSection?.content?.find((item) => item.type === 'text');
  if (firstText?.value) {
    return `${firstText.value.slice(0, 170)}${firstText.value.length > 170 ? '…' : ''}`;
  }
  return blog.summary || '';
};
